module.exports = __webpack_public_path__ + "static/media/5.97932b8c.png";